import getFulfilmentType, { FULFILMENT_TYPE } from "../../getFulfilmentType";

const shouldAddFlexibleSalesChannels = (sourceId, sellerId) => {
  const fulfilmentType = getFulfilmentType({ sourceId, sellerId });

  return (
    fulfilmentType === FULFILMENT_TYPE.AFS ||
    fulfilmentType === FULFILMENT_TYPE.PARTNER_FULFILS
  );
};

const buildItemObject = ({
  productId,
  productCode,
  variantId,
  title,
  brand,
  price,
  colour,
  variants,
  index
}) => {
  const getSize = () => {
    const selectedVariant = variants?.find(({ id }) => id === variantId);

    return selectedVariant ? selectedVariant.size : undefined;
  };

  const xrp = price?.xrp;
  const current = price?.current;

  return {
    productId: productId ? String(productId) : undefined,
    productCode: String(productCode),
    variantId: variantId ? String(variantId) : undefined,
    item_name: title,
    index: index + 1,
    item_brand: brand,
    price: xrp?.value || undefined,
    priceLocalCurrency: current?.value,
    quantity: 1,
    size: getSize(),
    item_variant: colour || undefined,
    google_business_vertical: "retail"
  };
};

const addStockProperties = (
  item,
  {
    isProductSellingFast,
    isVariantLowInStock,
    isVariantInStock,
    isProductInStock
  }
) => {
  if (isProductSellingFast !== undefined)
    item.isSellingFast = isProductSellingFast;
  if (isVariantLowInStock !== undefined)
    item.isLowInStock = isVariantLowInStock;
  if (isVariantInStock !== undefined) item.isInStock = isVariantInStock;
  if (isProductInStock !== undefined) item.isProductInStock = isProductInStock;
};

const addDiscountProperties = (item, price) => {
  const { wasPrice, current } = price || {};
  if (wasPrice?.value && current?.value && wasPrice.value > current.value) {
    item.hasDiscount = true;
    item.discountPercentage = Math.round(
      ((wasPrice.value - current.value) / wasPrice.value) * 100
    );
  }
};

const addProductFlags = (item, { earlyAccess, isRestockingSoon }) => {
  if (earlyAccess?.customerAccess)
    item.earlyAccess = earlyAccess.customerAccess;
  if (isRestockingSoon !== undefined) item.isRestockingSoon = isRestockingSoon;
};

const itemDataTemplate = (
  {
    productId,
    productCode,
    variantId,
    brand,
    colour,
    title,
    price,
    variants,
    source,
    seller,
    isProductSellingFast,
    isVariantLowInStock,
    isVariantInStock,
    isProductInStock,
    earlyAccess,
    isRestockingSoon
  },
  index = 0
) => {
  const item = buildItemObject({
    productId,
    productCode,
    variantId,
    brand,
    colour,
    title,
    price,
    variants,
    index
  });

  const sourceId = source?.id ?? null;
  const sellerId = seller?.id ?? null;

  if (shouldAddFlexibleSalesChannels(sourceId, sellerId)) {
    item.flexibleSalesChannels = {
      sourceId,
      sellerId
    };
  }

  addStockProperties(item, {
    isProductSellingFast,
    isVariantLowInStock,
    isVariantInStock,
    isProductInStock
  });
  addDiscountProperties(item, price);
  addProductFlags(item, { earlyAccess, isRestockingSoon });

  return item;
};

export default itemDataTemplate;
